import { serializeParams } from './params';
export const buildUrl = (path, baseUrl, params) => {
    const query = serializeParams(params);
    if (baseUrl) {
        const normalizedBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
        const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
        const url = new URL(normalizedPath, normalizedBase);
        if (query) {
            new URLSearchParams(query).forEach((value, key) => {
                url.searchParams.append(key, value);
            });
        }
        return url.toString();
    }
    if (!query) {
        return path;
    }
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}${query}`;
};
